import React from "react";
import { Clock, Hourglass } from "lucide-react";
import { useApp } from "@/context/AppContext";

// Shown app-wide to open-signup members whose account is awaiting admin approval,
// or who joined during a full Soft Launch and are on the waitlist.
export default function PendingBanner() {
  const { user } = useApp();
  if (!user) return null;

  if (user.approval_status === "waitlisted") {
    return (
      <div data-testid="waitlist-banner" className="w-full bg-amber-400/10 border-b border-amber-400/30">
        <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center gap-2.5 text-[13px]">
          <Hourglass size={15} className="text-amber-400 shrink-0" />
          <p className="text-sec leading-snug">
            <b className="text-amber-400">You're on the waitlist. 🌍</b> Our Soft Launch is currently full, so we're welcoming new members in small batches. We'll email you the moment a spot opens — feel free to explore in the meantime.
          </p>
        </div>
      </div>
    );
  }

  if (user.approval_status !== "pending") return null;
  return (
    <div data-testid="pending-approval-banner" className="w-full bg-brand/10 border-b border-brand/25">
      <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center gap-2.5 text-[13px]">
        <Clock size={15} className="text-brand shrink-0" />
        <p className="text-sec leading-snug">
          <b className="text-brand">Welcome to the family. 🌍</b> Your account is awaiting a quick welcome-approval — feel free to explore. A few actions (AI tools, hosting & communities) unlock the moment our team approves you, usually within a day.
        </p>
      </div>
    </div>
  );
}
